import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { ContentListItem as ContentListItemType } from '@widgets/UserProfile/types'
import SvgIcon from '@components/SvgIcon'
import ContentListItemClickableWrapper from '@components/UserProfilePage/ContentList/ContentListItemClickableWrapper'

const StyledContentItem = styled.li`
  ${({
    theme: {
      colors: { strokeWeak },
    },
  }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    height: 48px;

    list-style: none;
    border-bottom: 1px solid ${strokeWeak};

    &:last-child {
      border-bottom: none;
    }
  `}
`

const StyledContentItemText = styled.span`
  ${({
    theme: {
      typography: {
        bodycopy: {
          small1: { bundledCSS: small1BodycopyCSS },
        },
      },
      colors: { textDefault },
    },
  }) => css`
    flex-grow: 1;
    text-align: left;
    ${small1BodycopyCSS};
    color: ${textDefault};
  `}
`

type ContentListItemProps = ContentListItemType & {
  shouldShowSquareIcon?: boolean
}

const ContentListItem: FunctionComponent<ContentListItemProps> = ({
  shouldShowSquareIcon,
  ...item
}) => {
  const isClickable = item.type !== 'text'
  return (
    <StyledContentItem>
      <ContentListItemClickableWrapper item={item}>
        <SvgIcon iconName={item.iconName} size={24} />
        <StyledContentItemText>{item.name}</StyledContentItemText>
        {isClickable && (
          <SvgIcon
            iconName={
              shouldShowSquareIcon
                ? 'arrow-up-right-from-square'
                : 'arrow-right'
            }
            size={24}
          />
        )}
      </ContentListItemClickableWrapper>
    </StyledContentItem>
  )
}

export default ContentListItem
